module.exports = __webpack_public_path__ + "static/media/logo.7b52d901.svg";